import { useQueryClient } from '@tanstack/react-query';
import { useContext, useEffect } from 'react';
import ApiContext from '../../contexts/ApiContext';

export default function usePrefetchMandateIssuers() {
  const { paymentsApi } = useContext(ApiContext);
  const queryClient = useQueryClient();

  useEffect(() => {
    const prefetch = async () => {
      await queryClient.prefetchQuery({
        queryKey: ['getMandateIssuers'],
        queryFn: async () => {
          if (!paymentsApi) {
            throw new Error('paymentsApi is not available');
          }

          return paymentsApi.getMandateIssuers();
        },
      });
    };

    prefetch().catch(() => { });
  }, [paymentsApi]);
}
